import pythonApiClient from './pythonBaseApi';
import gestionReservasApi from './gestionReservasApi';

const BASE_PATHS = {
  reserva: '/procesos/hoteleria/gestion-reservas',
  checkin: '/procesos/hoteleria/gestion-checkin',
  checkout: '/procesos/hoteleria/gestion-checkout',
};

export const gestionAlojamientoApi = {
  getEstadosAsignacion: () => gestionReservasApi.getEstadosAsignacion(),

  getListado: (modo, proyectoId, params = {}) => {
    const base = BASE_PATHS[modo] || BASE_PATHS.reserva;
    return pythonApiClient.get(`${base}/proyecto/${proyectoId}/listado`, { params });
  },

  getPropuestaFechas: gestionReservasApi.getPropuestaFechas,
  actualizarFechasEstadia: gestionReservasApi.actualizarFechasEstadia,
  completarFechasEstadia: gestionReservasApi.completarFechasEstadia,
};

export default gestionAlojamientoApi;
